import React from 'react';
import { func, string } from 'prop-types';
import MessageHolder from 'components/messages/MessageHolder';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { withVisibilityLogic } from 'mangools-react-components/src';

function CreateExportSuccessMessage(props) {
    return (
        <MessageHolder onClose={props.onClose}>
            <div className="mg-modal-header is-success">
                <FontAwesomeIcon icon="check" aria-label="Success" />
            </div>
            <div className="mg-modal-content">
                <h3 className="font-30 uk-text-bold">Exporting has started</h3>
                <p className="uk-margin-top uk-margin-bottom">
                    Your export will be ready in about&nbsp;<strong>{props.readyIn}</strong>.
                    <br />
                    We&apos;ll send you an email with a download link to <strong>{props.email}</strong>
                    &nbsp;once it&apos;s all ready.
                </p>
                <button
                    className="mg-btn is-blue is-small uk-text-bold mg-margin-t-15"
                    onClick={props.onClose}
                    type="button"
                >
                    OK, great!
                </button>
            </div>
        </MessageHolder>
    );
}

CreateExportSuccessMessage.propTypes = {
    onClose: func.isRequired,
    readyIn: string.isRequired,
    email: string.isRequired,
};

export default withVisibilityLogic(CreateExportSuccessMessage);
